import { Button, styled, View } from 'tamagui';

export const CurrentPageContainer = styled(View, {
  /** Cell context */
  justifyContent: 'center',
  alignItems: 'center',

  /** Background arrangement */
  width: '$2',
  height: '$2',
  backgroundColor: '$secondary',
  borderRadius: '$5',
});

export const PageButton = styled(Button, {
  /** Cell context */
  justifyContent: 'center',
  alignItems: 'center',

  /** Background arrangement */
  width: '$2',
  height: '$2',
  borderRadius: '$5',
  padding: 0,

  /** Font arrangement */
  fontSize: '$2',
  color: '$color',
});
